var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenDisplaying, inlineEdit, hideWhenCreating } from 'src/types/columnFlags';
import TreeLookup from 'src/components/LookupDialogs/TreeLookup/TreeLookup.vue';
import Notify from 'quasar/src/plugins/Notify.js';;
import getSessionContext from 'src/utils/context/getSessionContext';
import rpc from 'src/api/rpc';
import repeatLastFetch from 'src/utils/entityOperations/repeatLastFetch';
import openDialogToConfirmIntendedAction from 'src/utils/dialogs/openDialogToConfirmIntendedAction';
import tryWithFullscreenLoading from 'src/utils/tryWithFullscreenLoading';
const controlledActions = {
    create: [48],
    fetch: [47],
    update: [323],
    delete: [324],
    downloadList: [-1],
    uploadList: [-1]
};
const rowMenuItems = [
    { name: 'delete', label: 'Delete', icon: 'mdi-delete', clickHandler: (props, ctx, e) => { ctx.deleteRow(e, ctx.getValueFromEnrichedData({ name: 'id', field: 'id' }, props.row)); } },
    {
        name: 'view_edit_controlled_actions',
        label: 'View or edit role permissions',
        icon: 'mdi-checkbox-multiple-marked-outline',
        clickHandler: (cellProps, ctx, e) => {
            ctx.setDialogComponentPlaceHolder(TreeLookup, {
                visibleProp: true,
                singleSelectProp: false,
                dataGetterProp: () => ctx.$store.dispatch('controlled_actions.controlled_actions_tree/fetch', { role_id: cellProps.row.id }),
                tickStrategyProp: 'leaf',
                titleProp: 'Select permissions available for this role',
                submitCallbackProp: ({ keysThatHaveBeenTickedSinceStart, keysThatHaveBeenUntickedSinceStart }) => __awaiter(void 0, void 0, void 0, function* () {
                    const payload = {
                        ca_ids_to_add: keysThatHaveBeenTickedSinceStart.map((r) => Number(r.replace('ca-', ''))),
                        ca_ids_to_remove: keysThatHaveBeenUntickedSinceStart.map((r) => Number(r.replace('ca-', ''))),
                        role_id: cellProps.row.id,
                        app_id: getSessionContext().app_id,
                        tenant_id: getSessionContext().tenant_id
                    };
                    const response = yield rpc('controlled_actions.change_ca_role_assignment', payload);
                    if (response.result === 'Success')
                        Notify.create({ message: 'Permissions have been successfully updated', color: 'positive' });
                })
            });
        }
    },
    {
        name: 'create_new_role_by_copying_this_role',
        label: 'Create new role by copying this role',
        icon: 'mdi-content-copy',
        clickHandler: (cellProps, ctx, e) => __awaiter(void 0, void 0, void 0, function* () {
            const roleId = cellProps.row.id;
            const intendedAction = () => __awaiter(void 0, void 0, void 0, function* () {
                tryWithFullscreenLoading(() => __awaiter(void 0, void 0, void 0, function* () {
                    const response = yield createNewRoleByCopyingExistingRole(roleId);
                    if (response.result === 'success') {
                        Notify.create({ message: 'New role has been successfully created', color: 'positive' });
                    }
                }));
            });
            const options = {
                intendedAction,
                message: 'Are you sure you want to create a new role by copying this role?  It will not be possible to remove a role from UI, created in such way.  If you are not sure, please consider creating a new role from scratch by clicking on plus button in the top right corner of the screen.'
            };
            openDialogToConfirmIntendedAction(options);
        })
    }
];
const columns = (state, getters, rootState, rootGetters) => {
    return [
        // @ts-ignore
        { name: 'row_menu', type: 'row_menu', style: 'width:50px', rowMenuItems: rowMenuItems, hideWhenCreating },
        { name: 'id', style: 'width:80px', isInteger, hideWhenDisplaying, hideWhenCreating },
        { name: 'name', inlineEdit }
    ];
};
const localEntity = constructLocalEntity({
    columns,
    remoteEntityName: 'controlled_actions.roles',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Roles'
});
export default localEntity;
export function createNewRoleByCopyingExistingRole(role_id) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = {
            action: 'select',
            api_version: 1,
            entity: 'controlled_actions.create_role_copy',
            action_arguments: [
                { argument_number: 1, type: 'int4', value: role_id }
            ]
        };
        const response = (yield rpc('generic_controllers.rpc', payload));
        if (response) {
            repeatLastFetch('controlled_actions.roles');
        }
        return response;
    });
}
